(() => {
  function initializeShippingPickers(scope = document) {
    for (const dialog of scope.querySelectorAll('[data-elite-shipping-picker]')) {
      if (dialog.dataset.shippingBound) continue;
      const root = document.getElementById(dialog.dataset.shippingRoot);
      const trigger = root?.querySelector('[data-a31-shipping-trigger]');
      const option = dialog.querySelector('[data-shipping-option]');
      const save = dialog.querySelector('[data-shipping-save]');
      const previous = dialog.querySelectorAll('[data-shipping-previous]');
      if (!trigger || !option || !save) continue;
      dialog.dataset.shippingBound = 'true';
      // Like the component picker, render outside the product's scoped styles.
      document.body.appendChild(dialog);
      const pcPrice = root.querySelector('.a31-price');
      const priceLabels = dialog.querySelectorAll('[data-shipping-pc-price]');
      function updatePrice() {
        for (const label of priceLabels) label.textContent = pcPrice?.textContent.trim() || 'Price unavailable';
      }
      const priceObserver = pcPrice && new MutationObserver(() => { if (dialog.open) updatePrice(); });
      priceObserver?.observe(pcPrice, { childList: true, characterData: true, subtree: true });

      let restoreTriggerFocus = true;
      let saved = false;
      let highlightTimer;
      function close(restoreFocus = true, savedSelection = false) {
        restoreTriggerFocus = restoreFocus;
        saved = savedSelection;
        if (dialog.open) dialog.close();
      }

      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        restoreTriggerFocus = true;
        saved = false;
        clearTimeout(highlightTimer);
        trigger.classList.remove('elite-pc-updated');
        const warranty = root.querySelector('[data-a31-component-key="warranty"]');
        previous.forEach(button => { button.disabled = !warranty || warranty.disabled; });
        updatePrice();
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('elite-shipping-picker-open');
        option.focus({ preventScroll: true });
      });
      option.addEventListener('click', () => {
        // Free UK delivery is the store's only shipping option.
        option.setAttribute('aria-pressed', 'true');
        save.focus({ preventScroll: true });
      });
      save.addEventListener('click', () => close(true, true));
      dialog.querySelector('[data-shipping-close]')?.addEventListener('click', () => close());
      previous.forEach(button => button.addEventListener('click', () => {
        const warranty = root.querySelector('[data-a31-component-key="warranty"]');
        if (!warranty || warranty.disabled) return;
        close(false);
        warranty.click();
      }));
      dialog.addEventListener('cancel', event => {
        event.preventDefault();
        close();
      });
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...dialog.querySelectorAll('button:not(:disabled), a[href]')]
          .filter(control => control.getClientRects().length);
        const target = event.shiftKey && document.activeElement === controls[0] ? controls.at(-1)
          : !event.shiftKey && document.activeElement === controls.at(-1) ? controls[0] : null;
        if (target) { event.preventDefault(); target.focus({ preventScroll: true }); }
      });
      let backdropPointerDown = false;
      function outsideDialog(event) {
        const bounds = dialog.getBoundingClientRect();
        return event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right
          || event.clientY < bounds.top || event.clientY > bounds.bottom);
      }
      dialog.addEventListener('pointerdown', event => { backdropPointerDown = outsideDialog(event); });
      dialog.addEventListener('click', event => {
        if (backdropPointerDown && outsideDialog(event)) close();
        backdropPointerDown = false;
      });
      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded', 'false');
        if (!document.querySelector('[data-elite-shipping-picker][open]')) {
          document.documentElement.classList.remove('elite-shipping-picker-open');
        }
        if (restoreTriggerFocus && trigger.isConnected) {
          trigger.focus({ preventScroll: true });
          if (saved) {
            trigger.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center', inline: 'nearest' });
            trigger.classList.add('elite-pc-updated');
            highlightTimer = setTimeout(() => trigger.classList.remove('elite-pc-updated'), 1500);
          }
        }
      });
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        priceObserver?.disconnect();
        clearTimeout(highlightTimer);
        close();
        dialog.remove();
      });
    }
  }

  initializeShippingPickers();
  document.addEventListener('shopify:section:load', event => initializeShippingPickers(event.target));
})();
